import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-map_pin",
  "use": "icon-map_pin-usage",
  "viewBox": "0 0 28 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 38\" id=\"icon-map_pin\"><path d=\"M13.735 20.87A7.143 7.143 0 0 1 6.6 13.735C6.6 9.801 9.801 6.6 13.735 6.6c3.934 0 7.135 3.201 7.135 7.135 0 3.934-3.2 7.135-7.135 7.135zm0-20.87C6.162 0 0 6.162 0 13.736a13.4 13.4 0 0 0 1.201 5.607c3.434 7.514 10.019 15.448 11.955 17.7a.765.765 0 0 0 1.159 0c1.936-2.251 8.52-10.185 11.955-17.7a13.393 13.393 0 0 0 1.201-5.607C27.471 6.162 21.31 0 13.735 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol